module.exports = __webpack_public_path__ + "img/cruise-placeholder1.92415e3.png";